// checkout — strona zamówienia (canvas 3, artboard „Checkout”).
// Klucze lustrzane z ../en/checkout.ts.
//
// ⚠️ STREFA CHRONIONA. Runda B-R3 (reguła 34) zmieniła słowo waluty na „token”
// w CAŁEJ reszcie tego ekranu — nagłówku, wierszu produktu, podsumowaniu — ale
// NIE w czterech oświadczeniach zgód (`consent.withdrawal`, `consent.terms`,
// `consent.withdrawalTopup`, `consent.termsTopup`). Tam dawne słowo stoi dalej,
// świadomie: zmiana idzie w jednym ruchu prawnym razem z `app/billing/consents.py`,
// Regulaminem i Polityką, i wtedy dopiero podbijamy wersje. Ekran mówiący
// „tokeny” nad zgodą mówiącą „gemy” jest niespójny, ale zgoda niezgodna co do
// znaku z zapisem w tabeli `consents` jest BEZ DOWODU — i to jest ta droższa
// niespójność.
//
// ⚠️ `consent.withdrawal` i `consent.terms` NIE SĄ COPY. To treść oświadczeń,
// które trafiają do tabeli `consents` razem z wersją dokumentu i są JEDYNYM
// dowodem przy chargebacku i przy sporze o prawo odstąpienia.
// KAŻDA zmiana choćby jednego znaku w tych dwóch stringach wymaga podbicia
// `TERMS_VERSION` / `WITHDRAWAL_VERSION` w `app/billing/consents.py` W TYM SAMYM
// PR (P01 pilnuje tego testem hashującym — OBJECT INFO-P01-007, ruling MGR 19:20).
// Inaczej dowód wskaże tekst, którego użytkownik nigdy nie widział.
//
// Brzmienie `consent.withdrawal` jest ŚWIADOMIE mocniejsze niż pierwsza wersja
// zgłoszona przez P01: opiera wyłączenie na zgodzie udzielonej PRZED UPŁYWEM
// TERMINU do odstąpienia (art. 38 pkt 13 u.p.k.), a nie tylko na „natychmiast”.
// To jest dokładnie luka, którą CRITIC zgłosił do B-10(b) — canvas ją zamyka.
//
// WARIANT TOP-UP (`*Topup`, D-020): ten sam ekran obsługuje też pakiet gemów,
// a pakiet NIE jest subskrypcją — „co miesiąc” i „automatyczne odnowienie” są
// przy nim po prostu nieprawdą, a fałszywa zgoda jest gorsza niż jej brak.
// Stąd osobne oświadczenia zamiast jednego z warunkiem w kodzie.
// `consent.withdrawalTopup` i `consent.termsTopup` są CO DO ZNAKU zgodne
// z `CONSENT_TEXTS[...][TOPUP]` w `app/billing/consents.py` — sprawdziłem oba
// twierdzenia faktyczne wobec wysłanego Regulaminu (r. „Gemy”: pakiety nie
// wygasają; r. „Zwroty”: niezużyty pakiet w całości, zużyty częściowo —
// proporcjonalnie) i obie się bronią, więc przyjmuję brzmienie P01 bez zmian.
// To NIE jest lenistwo redakcyjne: identyczny tekst = brak podbicia wersji
// i brak rozjazdu między tym, co użytkownik przeczytał, a tym, co zapisaliśmy.
export const checkout = {
  // Nagłówek ekranu bez produktu (06a–06f) i przy szkielecie: sama nazwa kroku.
  headingBare: 'Zamówienie',
  heading: 'Zamówienie - plan {plan}',
  // Katalog pakietów to 200 / 1000 / 5000 tokenów — każda z tych liczb bierze
  // dopełniacz „tokenów”, więc szyk naturalny jest tu bezpieczny.
  headingTopup: 'Zamówienie - pakiet {gems} tokenów',
  // Audyt 2026-09-04 #21: /order bez planu i bez pakietu to nie awaria — to brak
  // wyboru. Odpowiedzią jest katalog, nie „coś poszło nie tak po naszej stronie”.
  choose: {
    title: 'Wybierz, co chcesz kupić',
    body: 'Ten adres nie wskazuje ani planu, ani pakietu tokenów. Plany i pakiety są w cenniku; stan konta i bieżący plan - w Rozliczeniach.',
    pricing: 'Zobacz cennik',
    billing: 'Rozliczenia',
  },
  stale: {
    planTitle: 'Nie znamy takiego planu',
    planBody: 'Link mógł się zdezaktualizować. Nic nie zostało pobrane.',
    packTitle: 'Nie znamy takiego pakietu tokenów',
    packBody: 'Ten pakiet nie jest dostępny dla Twojego konta albo link się zdezaktualizował. Nic nie zostało pobrane.',
    currentPlans: 'Aktualne plany',
    currentPacks: 'Aktualne pakiety dla Twojego konta',
    pricing: 'Wybierz z cennika',
  },
  refusal: {
    title: 'Tego planu nie da się teraz kupić',
    body: 'To jest po naszej stronie, nie po Twojej. Nic nie zostało pobrane, a ponowna próba niczego nie zmieni. Napisz do nas albo wybierz inny plan.',
    contact: 'Napisz do nas',
    // Zdanie planu w miejsce `refusal.body`: fakt o pieniądzach, bez tłumaczenia się.
    nothingCharged: 'Nic nie pobrano.',
    otherPlan: 'Wybierz inny plan',
  },
  summary: {
    item: 'EDIMI {plan}',
    itemDesc: 'Dostęp do oprogramowania + {gems} tokenów co miesiąc + {accounts}',
    itemTopup: 'Pakiet {gems} tokenów',
    itemDescTopup: 'Zakup jednorazowy. Tokeny są ważne 24 miesiące od zakupu i zostają na koncie także po odnowieniu planu.',
    perMonth: 'miesięcznie',
    net: 'Wartość netto',
    vat: 'VAT {rate}% ({country})',
    dueToday: 'Do zapłaty dziś',
    vatNote: 'Cena zawiera VAT. Kolejne obciążenie {date}, potem co miesiąc.',
    // Bez „Kolejne obciążenie…”. Zapowiedź kolejnej płatności pod pakietem
    // jednorazowym to obietnica obciążenia, którego nie będzie.
    vatNoteOnce: 'Cena zawiera VAT. Płatność jednorazowa - bez odnowienia.',
  },
  // Bez `heading` / `cardDetails` (sesja 11, G7-32): formularz karty został wycięty (hosted Stripe
  // Checkout, D-020), więc copy dla pola, którego produkt z założenia nie ma, nie istnieje.
  payment: {
    // Zdanie, które zdejmuje najczęstszy lęk przed formularzem karty.
    stripeNote: 'Płatność obsługuje Stripe. Nie widzimy i nie przechowujemy danych Twojej karty.',
    descriptorLabel: 'Na wyciągu karty zobaczysz',
    descriptor: 'EDIMI',
    // Etykieta przycisku w locie do Stripe; przycisk zostaje przyciskiem.
    connecting: 'Łączę ze Stripe',
  },
  country: 'Kraj rozliczeniowy',
  countryPick: 'Wybierz kraj',
  // Sesja 11 (artboard 11): jedno zdanie o VAT zawsze, drugie TYLKO bez wybranego kraju.
  countryVat: 'Stawka VAT zależy od kraju rozliczeniowego.',
  countryMissing: 'Bez wybranego kraju nie policzymy VAT - wybierz kraj, żeby zobaczyć kwotę do zapłaty.',
  consent: {
    heading: 'Zanim zapłacisz',
    // Skrócone do zdania planu: nieaktywny przycisk mówi resztę (zasada 8).
    lead: 'Obie zgody są wymagane.',
    withdrawal: 'Żądam natychmiastowego dostępu do oprogramowania i gemów, przed upływem 14-dniowego terminu odstąpienia. Przyjmuję do wiadomości, że tracę prawo odstąpienia w zakresie już wykorzystanych gemów, a niewykorzystaną część rozliczymy proporcjonalnie.',
    terms: 'Akceptuję warunki subskrypcji: {price} brutto co miesiąc, automatyczne odnowienie do czasu anulowania, anulowanie w każdej chwili w portalu klienta. Akceptuję Regulamin i Politykę prywatności.',
    withdrawalTopup: 'Żądam natychmiastowego dostępu do kupowanych gemów, przed upływem 14-dniowego terminu odstąpienia. Przyjmuję do wiadomości, że tracę prawo odstąpienia w zakresie już wykorzystanych gemów, a niewykorzystaną część rozliczymy proporcjonalnie.',
    termsTopup: 'Akceptuję warunki zakupu: {price} brutto jednorazowo, bez odnowienia. Kupione gemy są ważne 24 miesiące od zakupu. Akceptuję Regulamin i Politykę prywatności.',
    termsLink: 'Regulamin',
    privacyLink: 'Politykę prywatności',
  },
  submit: 'Zapłać {price} i zacznij',
  // Bez kraju nie znamy kwoty, więc nie wpisujemy jej w etykietę przycisku.
  submitBare: 'Zapłać i zacznij',
  seller: 'Sprzedawca: JDG Dominik Łupicki',
  refundsLink: 'Zwroty i anulowanie',
  contactLink: 'Kontakt',
  priceChangeNote: 'O każdej zmianie ceny lub warunków informujemy z co najmniej 7-dniowym wyprzedzeniem.',
}
